"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactQuery = require("react-query");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTourBoardWidget = require("nicbase-tour-board-widget");

var _nicbaseTranslation = require("nicbase-translation");

var _latestDataDetails = _interopRequireDefault(require("./latest-data-details"));

var _tourDataViewAsset = _interopRequireDefault(require("./tour-data-view-asset"));

var _tourDataViewError = _interopRequireDefault(require("./tour-data-view-error"));

var _tourDataViewMap = _interopRequireDefault(require("./tour-data-view-map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var TourDataViewForm = function TourDataViewForm(_ref) {
  var _latestData$common, _latestData$common2, _tour$details;

  var tourToken = _ref.tourToken;

  // request to load tour
  var _useQuery = (0, _reactQuery.useQuery)(['tourDataView.tour'], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var url;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = new URL(ENV.tourDataViewRestAPI);
            url.searchParams.append('tourToken', tourToken);
            return _context.abrupt("return", fetch(url, {
              cache: 'no-cache'
            }).then(function (response) {
              if (response.ok) {
                return response.json();
              }

              throw new Error(response.statusText);
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), {
    enabled: !!tourToken,
    refetchInterval: 1000 * 60 * 5
  }),
      data = _useQuery.data,
      isLoading = _useQuery.isLoading,
      isError = _useQuery.isError;

  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, null);
  }

  if (isError || !tourToken || !data) {
    return /*#__PURE__*/_react["default"].createElement(_tourDataViewError["default"], null);
  }

  var _data$tour = data.tour,
      tour = _data$tour === void 0 ? {} : _data$tour,
      _data$latestData = data.latestData,
      latestData = _data$latestData === void 0 ? {} : _data$latestData;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pl-4 lg:pl-16 bg-gray-100"
  }, Boolean(tour.status) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "pl-4 lg:pl-8 font-bold mb-2"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.dataview.status"
  }), " ", /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tour.status.".concat(tour.status)
  })), Boolean(tour.details) && /*#__PURE__*/_react["default"].createElement(_tourDataViewAsset["default"], {
    className: "pl-4 lg:pl-8 mb-10",
    assetName: latestData.name,
    assetType: tour.assetType,
    latestDataStatus: (_latestData$common = latestData.common) === null || _latestData$common === void 0 ? void 0 : _latestData$common.status
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-1 flex-col lg:flex-row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr-8 lg:mr-0 lg:w-1/3"
  }, Boolean(tour.details) && /*#__PURE__*/_react["default"].createElement(_nicbaseTourBoardWidget.TourInfoBlockComponent, {
    tour: _objectSpread(_objectSpread({}, tour), tour.details),
    latestData: latestData
  }), Boolean(!tour.details) && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pl-4 lg:pl-8 mt-12 font-bold mb-3"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.dataview.latestData"
  })), /*#__PURE__*/_react["default"].createElement(_tourDataViewAsset["default"], {
    className: "pl-4 lg:pl-8 mb-3",
    assetName: latestData.name,
    assetType: tour.assetType,
    latestDataStatus: (_latestData$common2 = latestData.common) === null || _latestData$common2 === void 0 ? void 0 : _latestData$common2.status
  }), /*#__PURE__*/_react["default"].createElement(_latestDataDetails["default"], {
    tour: tour,
    latestData: latestData
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTourBoardWidget.Waypoints, {
    waypoints: tour.wayPoints,
    assetType: tour.assetType,
    status: tour.status,
    realStartTime: (_tour$details = tour.details) === null || _tour$details === void 0 ? void 0 : _tour$details.realStartTime,
    latestData: latestData
  })), /*#__PURE__*/_react["default"].createElement(_tourDataViewMap["default"], {
    waypoints: tour.wayPoints,
    tourAsset: latestData
  })));
};

TourDataViewForm.propTypes = {
  tourToken: _propTypes["default"].string
};
TourDataViewForm.defaultProps = {
  tourToken: null
};
var _default = TourDataViewForm;
exports["default"] = _default;